import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'components/AppRequest';
import GoogleAuth from './GoogleAuth';
import FacebookAuth from './FacebookAuth';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

class RegistrationForm extends Component {

  componentDidMount() {
    //add year in copyright
    // var date = new Date();
    // var yyyy = date.getFullYear();
    // document.getElementById('year').innerHTML = yyyy;
  }

  trans = (key) => {
    return TransHelper.translate( this.props.locale, 'content.auth.registrationForm.' + key);
  }

  render() {
    return (
      <div className="layout" style={{paddingTop: 0}}>
        <div className="branding-wrap">
          <header className="branding branding--airplane">
            <div className="cloud-top"></div>
            <div className="cloud-bottom"></div>
          </header>
        </div>

        <div className="wrapper">
          <div className="content">
            <div className="login">

              <p>{this.trans('title')}</p>

              <ul className="list-none socialmedia">
                <li className="socialmedia__item">
                  <GoogleAuth isRegister />
                </li>

                <li className="socialmedia__item">
                  <FacebookAuth isRegister />
                </li>
              </ul>

              <p className="separator"><span>{this.trans('or')}</span></p>

              <p className="mb-45">
                <AppLink to="routes.url.registrationStep1" className="button button--expand">
                  <FontAwesomeIcon
                    icon="envelope"
                    size="lg"
                    style={{ position: 'relative', left: '-10px' }}
                  />
                  {this.trans('signUpEmail')}
                </AppLink>
              </p>

              <div className="footer-bottons">
                <p>{this.trans('haveAccount')}</p>
                <p><AppLink to="routes.url.login">{this.trans('logIn')}</AppLink></p>
              </div>
            </div>
          </div>
        </div>

        {/*<p className="copyright">
          © <span id="year">2018</span> <a href="/" title="PKS Oslo - Homepage">PKS Oslo</a> all rights reserved
        </p>*/}
      </div>
    );
  };
}

export default RegistrationForm;